import {
  LIST_STUDY_DIAGNOSIS_REQUEST,
  LIST_STUDY_DIAGNOSIS_SUCCESS,
  LIST_STUDY_DIAGNOSIS_ERROR,
} from '../actions';

const INIT_STATE = {
  all: null,
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LIST_STUDY_DIAGNOSIS_REQUEST:
      return { ...state, loading: true, error: '' };
    case LIST_STUDY_DIAGNOSIS_SUCCESS:
      return {
        ...state,
        loading: false,
        all: action.payload,
        error: '',
      };
    case LIST_STUDY_DIAGNOSIS_ERROR:
      return {
        ...state,
        loading: false,
        all: null,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};
